export default "6b57498361d1ffd5.svg"